import React, { useRef } from "react";

import cn from "classnames";

import Email from "@mapmycustomers/shared/types/email/Email";

import { useIsOverflow } from "@app/util/hook/useIsOverflow";

import styles from "./ChildEmailBodyPreview.module.scss";
import EmailHtml from "./EmailHtml";

interface EmailBodyPreviewProps {
  className?: string;
  email: Email;
}

const ChildEmailBodyPreview: React.FC<EmailBodyPreviewProps> = ({ className, email }) => {
  const ref = useRef<HTMLDivElement>(null);
  const overflowed = useIsOverflow(ref);

  return (
    <div className={cn(styles.container, className)}>
      <EmailHtml
        className={cn({ [styles.overflowed]: overflowed })}
        email={email}
        ref={ref}
        showPreviousEmails={false}
      />
      {overflowed && <div className={styles.overflowOverlay} />}
    </div>
  );
};

export default ChildEmailBodyPreview;
